/** @module hooks/permissions */

import React from "react";
import { hooks, i18n } from "../util";
import rmlOpts from "rmlopts";

/**
 * This functions generates a tooltip text for the locked toolbar button.
 *
 * @params {object} props The properties
 * @params {string[]} props.restrictions The restrictions
 * @returns {React.Element}
 */
export const LockedToolTipText = _ref => {
  let {
    restrictions
  } = _ref;
  let inheritsCount = 0;
  return /*#__PURE__*/React.createElement("div", null, i18n("restrictionsSuffix"), /*#__PURE__*/React.createElement("br", null), restrictions.map(r => {
    const inherits = r.slice(-1) === ">",
      i18nKey = inherits ? r.slice(0, -1) : r;
    inherits && inheritsCount++;
    return /*#__PURE__*/React.createElement("div", {
      key: r
    }, "- ", i18n("restrictions." + i18nKey), inherits && /*#__PURE__*/React.createElement("strong", null, " *"));
  }), inheritsCount > 0 && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", null, "*"), " ", i18n("restrictionsInherits")));
};

/**
 * Show a locked button with tooltip in toolbar depending the permissions.
 *
 * @param {module:AppTree} element The AppTree
 * @param {object} [selected=Current] The node
 */
export default (function (element) {
  let selected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : element.getTreeItemById();
  let restrictions = [];
  const {
      currentFolderRestrictions,
      toolbar_locked
    } = element.state,
    lockedVisible = !!(selected && (restrictions = selected.properties.restrictions).length),
    lockedToolTipText = lockedVisible ? /*#__PURE__*/React.createElement(LockedToolTipText, {
      restrictions: restrictions
    }) : "";
  currentFolderRestrictions.join() !== restrictions.join() && element.setState({
    currentFolderRestrictions: restrictions || [],
    toolbar_locked: Object.assign(toolbar_locked, {
      visible: lockedVisible,
      toolTipText: lockedToolTipText
    })
  });
});

/**
 * A new node is pushed to the folder tree. We can modify it here that way that
 * a locked icon is shown.
 */
hooks.register("tree/node", node => {
  const {
    restrictions
  } = node.properties;
  if (restrictions.length) {
    node.className["rml-locked"] = true;
  }
});

/**
 * When a file is added do check if upload is allowed to this folder.
 */
hooks.register("uploader/add", function (file, _ref2, store) {
  let {
    properties
  } = _ref2;
  if (properties && properties.restrictions && properties.restrictions.join().indexOf("ins") > -1) {
    this.node = store.getTreeItemById(+rmlOpts.others.rootId, false);
    this.deny = i18n("restrictions.ins");
  }
});